// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

.nav-items-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  gap: 16px;
}

@media (max-width: 937px) and (min-width: 900px) {
  .nav-items-box {
    gap: 5px;
    white-space: nowrap;
  }
}

@media (max-width: 957px) and (min-width: 900px) {
  .logo-small {
    width: 125px;
    height: auto;
  }
}

@media (max-width: 488px) {
  .logo-small {
    width: 112px;
    height: auto;
  }
}

@media (max-width: 410px) {
  .logo-small {
    width: 105px;
    height: auto;
  }
}

@media (max-width: 390px) {
  .logo-small {
    display: none;
  }
}

.tabpanel {
  /* height: 485px; */
  min-height: 360px;
}

.table-icon {
  width: 35px;
}

.filterIcon * {
  fill: var(--icon-color) !important;
}

.dnaIcon path {
  stroke-width: 0.5px !important;
}

.dnaIcon path[fill="#3176B1"] {
  fill: var(--dna-primary-color) !important;
}

.dnaIcon path[fill="#023452"],
.dnaIcon path[stroke="#023452"] {
  fill: var(--dna-secondary-color) !important;
  stroke: var(--dna-secondary-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,QAAQ;IACR,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,2CAA2C;EAC3C,6CAA6C;AAC/C","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.nav-items-box {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  text-align: center;\n  gap: 16px;\n}\n\n@media (max-width: 937px) and (min-width: 900px) {\n  .nav-items-box {\n    gap: 5px;\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: 957px) and (min-width: 900px) {\n  .logo-small {\n    width: 125px;\n    height: auto;\n  }\n}\n\n@media (max-width: 488px) {\n  .logo-small {\n    width: 112px;\n    height: auto;\n  }\n}\n\n@media (max-width: 410px) {\n  .logo-small {\n    width: 105px;\n    height: auto;\n  }\n}\n\n@media (max-width: 390px) {\n  .logo-small {\n    display: none;\n  }\n}\n\n.tabpanel {\n  /* height: 485px; */\n  min-height: 360px;\n}\n\n.table-icon {\n  width: 35px;\n}\n\n.filterIcon * {\n  fill: var(--icon-color) !important;\n}\n\n.dnaIcon path {\n  stroke-width: 0.5px !important;\n}\n\n.dnaIcon path[fill=\"#3176B1\"] {\n  fill: var(--dna-primary-color) !important;\n}\n\n.dnaIcon path[fill=\"#023452\"],\n.dnaIcon path[stroke=\"#023452\"] {\n  fill: var(--dna-secondary-color) !important;\n  stroke: var(--dna-secondary-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
